import React from "react";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import SignIn from "../components/SignIn";

const Login = () => {
  return (
    <>
      <Navbar />
      <SignIn />

      <Footer />
    </>
  );
};

export default Login;
